import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./loyalty_signup_mode.js";
//#region src/loyalty_signup_mode_helper.ts
var loyalty_signup_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(loyaltySignupMode) {
	switch (loyaltySignupMode) {
		case "simple": return "Simple";
		case "instant-enroll": return "Instant Enroll";
	}
}
//#endregion
export { loyalty_signup_mode_helper_exports, name };

//# sourceMappingURL=loyalty_signup_mode_helper.js.map